import { useContext, useRef, useState } from "react";
import clevertap from "clevertap-web-sdk";

// components
import ListingStories from "components/ListingNew/ListingNormal/ListingStories";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";

// style
import "./style.scss";
import { HorizontalScroll } from "components/HorizontalScroll";
import { HomeScrollContainerHeader } from "components/NewHomePage/HomeScrollContainerHeader";
import useCheckEndsReached from "customHooks/useCheckEndsReached";
import { useSearchQuery } from "customHooks/useQuery";

const NewSearchHeighlights = ({ data }: any) => {
	const query = useSearchQuery();
	const width = useMediaQuery();
	const isLaptop = width < 1080 ? true : false;

	const [openStories, setOpenStories] = useState(false);
	const [num, setNum] = useState(0);

	const closeStories = () => {
		setOpenStories(false);
	};

	const listRef = useRef(null);

	const { reachedRight, reachedLeft } = useCheckEndsReached({
		ref: listRef,
	});

	return (
		<div className="search__heighlights__container">
			{/* {!isLaptop && (
				<HomeScrollContainerHeader
					heading={"Explore Highlights"}
					// @ts-ignore
					slideLeft={() => (listRef.current.scrollLeft += -500)}
					// @ts-ignore
					slideRight={() => (listRef.current.scrollLeft += 500)}
					reachedLeft={reachedLeft}
					reachedRight={reachedRight}
				/>
			)} */}
			<div className="stories__container" ref={listRef}>
				{data?.map((v: any, i: number) => {
					return (
						<>
							<div className="story-name">
								<button
									className="video_play-btn"
									title="play listing stories"
									aria-label="play listing stories"
									onClick={() => {
										setOpenStories(true);
										setNum(i);
										clevertap.event.push("highlights_search_page", {
											listing_id: v.id,
											name: `${v.name}`,
										});
									}}
									key={i}
								>
									<span className="video_play-btn-svg-container">
										<img
											src={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/${v.image}?tr=w-400,h-230`}
											alt={v.name}
											loading="lazy"
										/>
									</span>
								</button>
								<div className="villa-name-p">{v?.name?.split("-")[0]}</div>
							</div>
						</>
					);
				})}
			</div>
			{data?.length > 0 && data[num]?.id && (
				<ListingStories
					openStories={openStories}
					closeStories={closeStories}
					videos={data[num]?.data}
					setNum={setNum}
					total={data?.length}
					type={"search"}
					id={data[num]?.id}
					seoUrl={data[num]?.seo_url}
					query={query}
					// villaName={data[num]?.name}
					// villaImage={data[num]?.image}
				/>
			)}
		</div>
	);
};

export default NewSearchHeighlights;
